function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import { Button } from 'swag-client-common/components/ui/button';
import { ButtonFontSize, ButtonSize, ButtonTextTransform, ButtonType } from 'swag-client-common/components/ui/button/button';
import AddressBlock from '../address-block/address-block';
import classes from './popup-content.scss';
export default class PopupContent extends React.PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "getButtons", () => {
      const {
        confirmAddresses,
        buttonClassName,
        saveText = 'Save & Continue',
        onEditClick,
        onSubmitClick
      } = this.props;
      if (confirmAddresses.length > 1) {
        return /*#__PURE__*/React.createElement("div", {
          className: classes.buttons
        }, /*#__PURE__*/React.createElement(Button, {
          dataButton: "Continue",
          type: ButtonType.fullGreyGreyText,
          size: ButtonSize.large,
          fontSize: ButtonFontSize.small,
          className: classes.button,
          onClick: onEditClick,
          textTransform: ButtonTextTransform.none
        }, "Edit Address"), /*#__PURE__*/React.createElement(Button, {
          dataButton: "Confirm",
          type: ButtonType.primary,
          size: ButtonSize.large,
          fontSize: ButtonFontSize.small,
          className: classnames(classes.button, buttonClassName),
          onClick: onSubmitClick,
          textTransform: ButtonTextTransform.none
        }, saveText));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: classes.buttons
      }, /*#__PURE__*/React.createElement(Button, {
        dataButton: "Confirm",
        type: ButtonType.fullGreyGreyText,
        size: ButtonSize.large,
        fontSize: ButtonFontSize.small,
        className: classes.button,
        onClick: onSubmitClick,
        textTransform: ButtonTextTransform.none
      }, saveText), /*#__PURE__*/React.createElement(Button, {
        dataButton: "Continue",
        type: ButtonType.primary,
        size: ButtonSize.large,
        fontSize: ButtonFontSize.small,
        className: classnames(classes.button, buttonClassName),
        onClick: onEditClick,
        textTransform: ButtonTextTransform.none
      }, "Edit Address"));
    });
    _defineProperty(this, "getText", () => {
      const {
        confirmAddresses
      } = this.props;
      return confirmAddresses.length > 1 ? "We couldn't verify the exact address that you entered, but did find a close match. Please make sure your mailing address is correct to ensure accurate delivery." : "We couldn't verify the exact address that you entered. Please double check to confirm it's correct or make any necessary changes.";
    });
  }
  render() {
    const {
      titleText = 'Confirm your address',
      onAddressClick,
      confirmAddresses,
      activeBorderClassName,
      chosenAddress
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.container
    }, /*#__PURE__*/React.createElement("h2", {
      className: classes.header
    }, titleText), /*#__PURE__*/React.createElement("p", {
      className: classes.text
    }, this.getText()), /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.list, {
        [classes.center]: confirmAddresses.length === 1
      })
    }, confirmAddresses.map(addressEntity => /*#__PURE__*/React.createElement(AddressBlock, {
      key: addressEntity.addressType,
      addressEntity: addressEntity,
      chosenAddress: chosenAddress,
      isComparing: confirmAddresses.length > 1,
      onAddressClick: onAddressClick,
      activeBorderClassName: activeBorderClassName
    }))), this.getButtons());
  }
}